import React, { useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

const NavBarComponent = () => {
  const { token, setToken, role, accountId } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  // Hide navbar on login page or if not logged in
  if (location.pathname === '/' || !token) return null;

  const handleLogout = () => {
    setToken(null);
    localStorage.removeItem('token');
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-links">
        {role === 'coach' && (
          <>
            <Link to="/coachdashboard" className="nav-link">Teams</Link>
            <Link to="/players" className="nav-link">Players</Link>
            <Link to="/club" className="nav-link">Club</Link> {/* NEW */}
          </>
        )}

        {role === 'player' && (
          <Link to={`/player/${accountId}`} className="nav-link">Player</Link>
        )}

        <Link to="/profile" className="nav-link">Profile</Link>
      </div>

      <div className="navbar-logout">
        <button onClick={handleLogout} className="nav-link nav-button">Logout</button>
      </div>
    </nav>
  );
};

export default NavBarComponent;
